const formatters = [
  Intl.NumberFormat('en-US', { maximumFractionDigits: 0, style: 'percent' }),
  Intl.NumberFormat('en-US', { maximumFractionDigits: 1, style: 'percent' }),
  Intl.NumberFormat('en-US', { maximumFractionDigits: 2, style: 'percent' }),
]

const formatPercent = (value: number, digits: 0 | 1 | 2 = 0) => formatters[digits].format(value)

export default formatPercent
